import PropTypes from 'prop-types'

/**
 * @param {String} color - color of the Icon
 * @returns {React.ReactNode} - return a Heart Icon. 
 */

export function Heart(props) {

    const {color = "currentColor" } = props;
    
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.8042 1.90472C13.0232 0.685176 14.6769 0 16.4013 0C18.1256 0 19.7792 0.685114 20.9982 1.90455C22.2177 3.12359 22.9031 4.77755 22.9031 6.50183C22.9031 8.22618 22.2179 9.87988 20.9984 11.0989C20.9983 11.099 20.9985 11.0989 20.9984 11.0989L12.1584 19.9389C11.7679 20.3295 11.1347 20.3295 10.7442 19.9389L1.90418 11.0989C-0.634728 8.56002 -0.634728 4.44363 1.90418 1.90472C4.4431 -0.634193 8.55949 -0.634193 11.0984 1.90472L11.4513 2.25761L11.8042 1.90472C11.8042 1.90466 11.8041 1.90477 11.8042 1.90472ZM16.4013 2C15.2075 2 14.0625 2.4744 13.2186 3.31877L12.1584 4.37893C11.9709 4.56647 11.7165 4.67183 11.4513 4.67183C11.1861 4.67183 10.9317 4.56647 10.7442 4.37893L9.68418 3.31893C7.92632 1.56107 5.07626 1.56107 3.3184 3.31893C1.56053 5.0768 1.56053 7.92686 3.3184 9.68472L11.4513 17.8176L19.5842 9.68472C20.4286 8.84074 20.9031 7.69567 20.9031 6.50183C20.9031 5.30799 20.4287 4.16307 19.5843 3.3191C18.7404 2.47473 17.5951 2 16.4013 2Z" fill={color} />
        </svg>

    );
}

Heart.propTypes = {
    color: PropTypes.string
}


